import React from 'react';

const ProductsTab = ({ products, onOpenModal, onDeleteProduct, getImageUrl }) => {
    return (
        <div className="admin-tab-content">
            <div className="admin-card">
                <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3>Products Catalog ({products.length})</h3>
                    <button className="admin-btn admin-btn-primary" onClick={() => onOpenModal('product')}>
                        <i className="fa fa-plus m-r5" /> Add New Product
                    </button>
                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th>Image</th>
                                    <th>Title</th>
                                    <th>Category</th>
                                    <th>Slug</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {products.map((p) => (
                                    <tr key={p.id}>
                                        <td>
                                            <img
                                                src={getImageUrl(p.mainImage)}
                                                alt={p.title}
                                                onError={(e) => { e.target.onerror = null; e.target.style.opacity = '0.6'; }}
                                                style={{ width: '60px', height: '45px', objectFit: 'cover', borderRadius: '6px' }}
                                            />
                                        </td>
                                        <td><strong>{p.title}</strong></td>
                                        <td><span className="admin-pill bg-orange">{p.category}</span></td>
                                        <td><code>{p.slug}</code></td>
                                        <td>
                                            <button className="admin-btn-icon btn-edit" onClick={() => onOpenModal('product', p)}>
                                                <i className="fa fa-pencil" />
                                            </button>
                                            <button className="admin-btn-icon btn-delete" onClick={() => onDeleteProduct(p.id)}>
                                                <i className="fa fa-trash" />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductsTab;
